import React from 'react';
import classNames from "classnames";

import {ContextMenuInlineItem, ContextMenuInlineItemProps} from "./ContextMenuInlineItem";


import './ContextMenuInline.css';


export interface ContextMenuInlineItemInParams extends ContextMenuInlineItemProps {
    id: string;
}

export interface ContextMenuInlineProps {
    handleClose: () => void;
    buttonsSet: ContextMenuInlineItemInParams[];
    isDark?: boolean;
}

export const ContextMenuInline = (
    {
        buttonsSet,
        handleClose,
        isDark,
    }: ContextMenuInlineProps
) => {
    return (
        <div className={classNames({
            'ContextMenuInline': true,
            'theme-dark': isDark
        })}>
            {
                buttonsSet.map(button => {
                    return (
                        <ContextMenuInlineItem
                            key={button.id}
                            isActive={button.isActive}
                            handleClose={handleClose}
                            onClick={button.onClick}
                            Icon={button.Icon}
                            getTooltip={button.getTooltip}
                            hotKey={button.hotKey}
                        />
                    )
                })
            }
        </div>
    )
}
